import { lazyload } from '@/lib/lazy-load'

import { GridImportModal } from './GridImportModal'

const MarkAsUserTableModal = lazyload(() => import('./MarkAsUserTableModal'))
const GridPreviewModal = lazyload(() => import('./GridPreviewModal'))
const SnapshotAlertModal = lazyload(() => import('./SnapshotAlertModal'))

export function GridModals() {
  return (
    <>
      <MarkAsUserTableModal />
      <GridImportModal />
      <GridPreviewModal />
      <SnapshotAlertModal />
    </>
  )
}
